import isEmpty from "lodash.isempty";
import omitBy from "lodash.omitby";
import qs from "qs";

const getQueryString = (query) => {
  const nonEmptyQuery = omitBy(query, isEmpty);

  return qs.stringify(nonEmptyQuery, {
    format: "RFC1738",
    indices: false,
  });
};

export default getQueryString;
